import { apiClient } from './api-client';
import { AuthResponse, User, UpdateProfileData, ChangePasswordData, UserSettings, OpportunityCriteriaData } from '@/types/index';

export const authService = {
  async register(email: string, password: string, name?: string) {
    return apiClient.post<AuthResponse>('/auth/register', {
      email,
      password,
      name,
    });
  },

  async login(email: string, password: string) {
    return apiClient.post<AuthResponse>('/auth/login', {
      email,
      password,
    });
  },

  async getProfile() {
    return apiClient.get<User>('/auth/profile');
  },

  async updateProfile(data: UpdateProfileData) {
    const updatedUser = await apiClient.patch<User>('/auth/profile', data);
    // Mettre à jour localStorage si l'utilisateur existe
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      const newUser = { ...user, ...updatedUser };
      localStorage.setItem('user', JSON.stringify(newUser));

      // Déclencher un événement pour notifier les composants React
      window.dispatchEvent(new CustomEvent('user-updated', {
        detail: newUser
      }));
    }
    return updatedUser;
  },

  async changePassword(data: ChangePasswordData) {
    return apiClient.post<{ message: string }>('/auth/change-password', {
      currentPassword: data.currentPassword,
      newPassword: data.newPassword,
    });
  },

  async getSettings() {
    return apiClient.get<UserSettings>('/auth/settings');
  },

  async updateSettings(data: OpportunityCriteriaData | Partial<UserSettings>) {
    return apiClient.patch<UserSettings>('/auth/settings', data);
  },

  async createApiKey(name: string) {
    return apiClient.post<{ id: string; name: string; keyPrefix: string; rawKey: string; createdAt: string }>('/auth/api-keys', { name });
  },

  async listApiKeys() {
    return apiClient.get<{ id: string; name: string; keyPrefix: string; isActive: boolean; lastUsedAt: string | null; createdAt: string }[]>('/auth/api-keys');
  },

  async revokeApiKey(id: string) {
    return apiClient.delete<void>(`/auth/api-keys/${id}`);
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  setToken(token: string) {
    localStorage.setItem('token', token);
  },

  async forgotPassword(email: string): Promise<void> {
    await apiClient.post('/auth/forgot-password', { email });
  },

  async resetPassword(token: string, password: string): Promise<void> {
    await apiClient.post('/auth/reset-password', { token, password });
  },

  getToken() {
    return localStorage.getItem('token');
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },
};
